<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>remove</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Remove Housing Unit</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              v-html="'Are you sure to remove the unit <strong>' + unitObject.name + '</strong>'"
            ></v-flex>
            <v-flex>
              <v-alert :value="true" type="error" v-if="error">{{error}}</v-alert>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn flat @click="dialog = false">
          <v-icon>close</v-icon>Close
        </v-btn>
        <v-spacer />
        <v-btn flat @click="removeUnit">
          <v-icon>remove</v-icon>Remove
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    removeUnit() {
      this.error = null;
      this.$store
        .dispatch("duo/removeUnit", {
          uuid: this.unitUuid
        })
        .then(() => {
          this.dialog = false;
        })
        .catch(e => {
          console.log(e.response.data);
          this.error = e.response.data.message || e;
        });
    }
  },
  props: {
    unitObject: Object,
    unitUuid: String
  },

  data() {
    return {
      dialog: false,
      error: null
    };
  }
};
</script>
